import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { HistoryData } from '../history-data/HistoryData';

/**
 * # ProjectHistory
 *
 * ProjectHistory을 설명하세요.
 */
export const ProjectHistory = types
  .model('ProjectHistory')
  // --------------------------------------------------------------------------
  .props({
    projectSid: types.maybeNull(types.number),
    roundData: types.maybeNull(types.optional(types.array(HistoryData), [])),

    // estimateSheetHistory: types.optional(types.array(HistoryData), []),
    // mspHistory: types.optional(types.array(HistoryData), []),
    // bizDraftNoHistory: types.optional(types.array(HistoryData), []),
    // salesRepHistory: types.optional(types.array(HistoryData), []),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model projectHistory --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IProjectHistory;
      (Object.keys(newProps) as TProjectHistoryKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TProjectHistory = Instance<typeof ProjectHistory>;
type TProjectHistorySnapshot = SnapshotOut<typeof ProjectHistory>;

export interface IProjectHistory extends TProjectHistory {}
export type TProjectHistoryKeys = keyof TProjectHistorySnapshot & string;
export interface IProjectHistorySnapshot extends TProjectHistorySnapshot {}
export const createProjectHistory = () => types.optional(ProjectHistory, {} as TProjectHistory);
